import { useApolloClient } from '@apollo/client';

import BrowseComplexCollectionDocumentNode from 'bundles/browse-common/queries/BrowseComplexCollection.graphql';
import type {
  BrowseComplexCollectionQuery,
  BrowseComplexCollectionQueryVariables,
} from 'bundles/browse-common/queries/__generated__/BrowseComplexCollection';

type Props = {
  queryCollectionId: string;
  additionalInput: unknown;
};

export function useQueryBrowseComplexCollection() {
  const apolloClient = useApolloClient();

  return (props: Props) => {
    return apolloClient.query<BrowseComplexCollectionQuery, BrowseComplexCollectionQueryVariables>({
      query: BrowseComplexCollectionDocumentNode,
      variables: {
        queryCollectionId: props.queryCollectionId,
        additionalInput: props.additionalInput,
      },
      context: {
        clientName: 'gatewayGql',
      },
      errorPolicy: 'all',
    });
  };
}
